import { CIUDAD, CLIENTE, CLIENTE_DIRECCION_PROFORMA, logistica_GUIA, logistica_MANIFIESTO_PROFORMA, USUARIO } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { PayloadAction } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import { baseURL, establecerEstado, handleResponse, headers, limpiarEstado, reestablecerEstado, seteaError, structureInfoState } from "../helpersRedux";
import { setAgenciasDelDestinatario, setBusquedaCliente, setCiudadesConsulta, setDestinatariosConsulta, setGuiaConDetalles, setGuiasConsulta, setManifiestosProformasConsulta, setMisDestinatarioConsulta } from "../slices/consultaSlice";

//logistica_GUIA
export const conseguirGuiasRecientes = (desde: string, hasta: string, numeroDocumentoRelacionado: number, nombreDestinatario: string,
  estado: string, idCiudadDestino: number, idCiudadOrigen: number, numeroDocumento: number, idUsuario: number) =>

  async (dispatch: (action: PayloadAction<structureInfoState<logistica_GUIA[]>>) => void) => {
    dispatch(setGuiasConsulta(reestablecerEstado()))
    const response = await axios.get(`${baseURL}logistica_GUIA/?idCiudadOrigen=${idCiudadOrigen}&idCiudadDestino=${idCiudadDestino}&desde=${desde}&hasta=${hasta}&estado=${estado}&nombreDestinatario=${nombreDestinatario}&numeroDocumentoRelacionado=${numeroDocumentoRelacionado}&numeroDocumento=${numeroDocumento}&idUsuario=${idUsuario}`, headers)
      .then((res: AxiosResponse<IApiResponse<logistica_GUIA[]>>) => handleResponse(res))
    dispatch(setGuiasConsulta(establecerEstado(response)))
  };


export const limpiarGuiasRecientesSinLoading = () =>
  async (dispatch: (action: PayloadAction<structureInfoState<logistica_GUIA[]>>) => void) => {
    dispatch(setGuiasConsulta(limpiarEstado()))
  }

export const buscarGuiaPorNumero = (serie1: string, serie2: string, numeroDocumento: number) =>
  async (dispatch: (action: PayloadAction<structureInfoState<logistica_GUIA>>) => void) => {
    try {
      dispatch(setGuiaConDetalles(limpiarEstado(new logistica_GUIA())))

      const response = await axios.get(`${baseURL}logistica_GUIA/detalles?serie1=${serie1}&serie2=${serie2}&numeroDocumento=${numeroDocumento}`, headers)
        .then((res: AxiosResponse<IApiResponse<logistica_GUIA>>) => handleResponse(res))
      dispatch(setGuiaConDetalles(establecerEstado(response)))
    } catch (error) {
      if (error instanceof Error) {
        dispatch(setGuiaConDetalles(seteaError(error, new logistica_GUIA())))
      }
    }
  };

//logistica_MANIFIESTO_PROFORMA
export const buscarManifiestosProformas = (desde: string, hasta: string, estado: string, serie1: string, serie2: string, numeroDocumento: number, idUsuario: number) =>
  async (dispatch: (action: PayloadAction<structureInfoState<logistica_MANIFIESTO_PROFORMA[]>>) => void) => {
    try {
      dispatch(setManifiestosProformasConsulta(reestablecerEstado()))
      let response = await axios.get(`${baseURL}logistica_MANIFIESTO_PROFORMA?estado=${estado}&desde=${desde}&hasta=${hasta}&serie1=${serie1}&serie2=${serie2}&numeroDocumento=${numeroDocumento}&idUsuario=${idUsuario}`, headers)
        .then((res: AxiosResponse<IApiResponse<logistica_MANIFIESTO_PROFORMA[]>>) => handleResponse(res))
      dispatch(setManifiestosProformasConsulta(establecerEstado(response)))
    } catch (error) {
      if (error instanceof Error)
        dispatch(setManifiestosProformasConsulta(seteaError(error)))
    }
  }
export const limpiarManifiestoProformaSinLoading = () =>
  async (dispatch: (action: PayloadAction<structureInfoState<logistica_MANIFIESTO_PROFORMA[]>>) => void) => {
    dispatch(setManifiestosProformasConsulta(limpiarEstado()))
  }


//CIUDADES
export const obtenerCiudadesConsulta = () =>
  async (dispatch: (action: PayloadAction<structureInfoState<CIUDAD[]>>) => void) => {
    dispatch(setCiudadesConsulta(limpiarEstado()))
    try {
      const response = await axios.get(`${baseURL}CIUDAD`, headers)
        .then((res: AxiosResponse<IApiResponse<CIUDAD[]>>) => handleResponse(res))
      dispatch(setCiudadesConsulta(establecerEstado(response)))
    } catch (error) {
      if (error instanceof Error)
        dispatch(setCiudadesConsulta(seteaError(error)))
    }
  };

//CLIENTE (solo trae el nombre y el id)
export const obtenerDestinatarios = (desde: string, hasta: string) =>
  async (dispatch: (action: PayloadAction<structureInfoState<CLIENTE[]>>) => void) => {
    try {
      dispatch(setDestinatariosConsulta(limpiarEstado()))
      const response = await axios.get(`${baseURL}CLIENTE/recientes?desde=${desde}&hasta=${hasta}`, headers)
        .then((res: AxiosResponse<IApiResponse<CLIENTE[]>>) => handleResponse(res))
      dispatch(setDestinatariosConsulta(establecerEstado(response)))
    } catch (error) {
      if (error instanceof Error)
        dispatch(setDestinatariosConsulta(seteaError(error)))
    }
  };

//Mis Destinatarios
export const obtenerMisDestinatarios = (idUsuario: number, query: string) =>
  async (dispatch: (action: PayloadAction<structureInfoState<CLIENTE[]>>) => void) => {
    dispatch(setMisDestinatarioConsulta(reestablecerEstado()))
    try {
      const response = await axios(`${baseURL}USUARIO/${idUsuario}/USUARIO_CLIENTE/misDestinatarios?query=${query}`, headers)
        .then((res: AxiosResponse<IApiResponse<CLIENTE[]>>) => handleResponse(res))
      dispatch(setMisDestinatarioConsulta(establecerEstado(response)))
    } catch (error) {
      if (error instanceof Error)
        dispatch(setMisDestinatarioConsulta(seteaError(error)))
    }
  }

export const obtenerAgenciasDelDestinatario = (idCliente: number) =>
  async (dispatch: (action: PayloadAction<structureInfoState<CLIENTE_DIRECCION_PROFORMA[]>>) => void) => {
    dispatch(setAgenciasDelDestinatario(limpiarEstado()))
    try {
      const response = await axios(`${baseURL}CLIENTE/${idCliente}/CLIENTE_DIRECCION_PROFORMA`, headers)
        .then((res: AxiosResponse<IApiResponse<CLIENTE_DIRECCION_PROFORMA[]>>) => handleResponse(res))
      dispatch(setAgenciasDelDestinatario(establecerEstado(response)))
    } catch (error) {
      if (error instanceof Error)
        dispatch(setAgenciasDelDestinatario(seteaError(error)))
    }
  }
export const obtenerClientesPorQuery = (query: string) =>
  async (dispatch: (action: PayloadAction<structureInfoState<CLIENTE[]>>) => void) => {
    dispatch(setBusquedaCliente(reestablecerEstado()))
    try {
      const limiteResultados = 100
      const response = await axios(`${baseURL}CLIENTE?identificacion=${query}&razonSocial=${query}&items=${limiteResultados}&filtrarPorCoincidenciaExacta=false`, headers)
        .then((res: AxiosResponse<IApiResponse<CLIENTE[]>>) => handleResponse(res))
      dispatch(setBusquedaCliente(establecerEstado(response)))
    } catch (error) {
      if (error instanceof Error)
        dispatch(setBusquedaCliente(seteaError(error)))
    }
  }

export const limpiarAgenciasDelDestinatario = () =>
  (dispatch: (action: PayloadAction<structureInfoState<CLIENTE_DIRECCION_PROFORMA[]>>) => void) => {
    dispatch(setAgenciasDelDestinatario(limpiarEstado()))
  }

export const limpiarConsultaSlice = (tipo: "guias" | "manifiestos" | "todos") =>
  async (dispatch: (action: PayloadAction<structureInfoState<USUARIO[] | logistica_MANIFIESTO_PROFORMA[] | logistica_GUIA[] | CIUDAD[]>>) => void) => {
    dispatch(setCiudadesConsulta(reestablecerEstado()))
    if (tipo === "guias")
      dispatch(setGuiasConsulta(reestablecerEstado()))
    else if (tipo === "manifiestos")
      dispatch(setManifiestosProformasConsulta(reestablecerEstado()))
    else if (tipo === "todos") {
      dispatch(setGuiasConsulta(reestablecerEstado()))
      dispatch(setManifiestosProformasConsulta(reestablecerEstado()))
    }

  }

